// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_labor-information {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: calc(85vh - 120px);
}`, "",{"version":3,"sources":["webpack://./src/infraestructure/pages/labor-information/style.scss"],"names":[],"mappings":"AACC;EACG,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,8BAAA;AAAJ","sourcesContent":[" \n .container_labor-information {\n    display: flex;\n    flex-direction: column;\n    align-items: center;  \n    min-height: calc(85vh - 120px);\n }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
